import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cRDB'
})
export class CRDBPipe implements PipeTransform {

  transform(value: string,): any {
    return this.crDBFilter(value);
  }

  crDBFilter(val: string){
    var Amt = Number(String(val).replace(/\,/g, ""));
    //var Removemi = Math.abs(Amt).toFixed(2);
    var Removemi = Number(Amt).toLocaleString('hi-IN', {
        style: "currency",
        currency: "INR"
    });
    var a = (Removemi + ((Amt < 0) ? " Cr" : " Db")).replace("₹", "");
    return String(a).replace("-", "");
  }

}
